import NotificationBadge from "../../components/ui/NotificationBadge";
import TimerRing from "../../components/ui/TimerRing";
import ScenarioTracker from "../../components/ui/ScenarioTracker";
import MissionPanel from "../../components/ui/MissionPanel";
import PersonalNotes from "../../components/ui/PersonalNotes";
import SharedPanel from "../../components/ui/SharedPanel";
import { HUD_STYLES } from "../../components/ui/GameHudStyles";

export default function GameHudLeft({
  timeLeft, formatTime, sessionDuration,
  code, me,
  toggleHandRaise, myHandRaised,
  voteGateActive, setAdvanceModalOpen, myVote, waitingCount,
  leftTab, setLeftTab, setNotif, notif, leftTabRef,
  state, missionGuide, missionFilter, setMissionFilter,
  inventory,
}) {
  return (
    <aside className="hidden [@media(min-width:1420px)]:flex w-72 h-[100dvh] max-h-[100dvh] flex-col py-3 px-3 gap-3 overflow-hidden">
      <style>{HUD_STYLES}</style>
      <div className="hud-panel hud-panel-cyan" style={{ gap: 0, flex: 1, minHeight: 0 }}>
        <TimerRing timeLeft={timeLeft} formatTime={formatTime} totalSeconds={sessionDuration} />

        <div className="hud-sec">
          <div className="hud-jrn-card">
            <ScenarioTracker sessionCode={code} />
          </div>
        </div>

        <div className="hud-sec">
          <div style={{ display: "flex", gap: 6 }}>
            <button type="button" onClick={toggleHandRaise}
              className={`hud-abtn ${myHandRaised ? "hud-abtn-hand-active" : "hud-abtn-hand"}`}>
              ✋ Lever la Main
            </button>
            {voteGateActive && (
              <button type="button" onClick={() => setAdvanceModalOpen(true)} className="hud-abtn hud-abtn-vote">
                🗳 Vote{" "}
                <span className="hud-vote-badge">
                  {myVote === "yes" ? "OK" : myVote === "no" ? "⛔" : waitingCount}
                </span>
              </button>
            )}
          </div>
        </div>

        <div className="hud-tab-bar">
          {[{ id: "mission", label: "Mission" }, { id: "notes", label: "Notes" }, { id: "shared", label: "Partagés" }].map(t => (
            <button key={t.id} type="button"
              onClick={() => { setLeftTab(t.id); setNotif(n => ({ ...n, [t.id]: 0 })); }}
              className={`hud-tab ${leftTab === t.id ? "hud-tab-on" : ""}`}
              style={{ position: "relative" }}>
              {t.label}
              {leftTab !== t.id && <NotificationBadge count={notif[t.id]} />}
            </button>
          ))}
        </div>

        <div style={{ padding: "10px 12px", flex: 1, minHeight: 0, overflowY: "auto", position: "relative", zIndex: 2 }} className="custom-scrollbar">
          {leftTab === "mission" && (
            <MissionPanel stage={state.stage || 1} items={missionGuide} filter={missionFilter} onFilterChange={setMissionFilter} />
          )}
          {leftTab === "notes" && <PersonalNotes storageKey={`notes:${code}:${me.id}`} />}
          {leftTab === "shared" && (
            <SharedPanel sessionCode={code} playerId={me.id}
              onNewShared={(delta) => {
                if (leftTabRef.current === "shared") return;
                setNotif(n => ({ ...n, shared: n.shared + (delta || 1) }));
              }}
            />
          )}
        </div>

        <div className="hud-inv">
          <div className="hud-inv-dot" />
          <div className="hud-inv-txt">
            {inventory[me.id]?.hasKeyJ4 ? "🔑 Clé du dictionnaire" : "Inventaire vide"}
          </div>
        </div>
      </div>
    </aside>
  );
}